export interface IRole {
  name: string;
  displayName: string;
  id: string;
  createdDate: string;
  updatedDate: string;
}

export enum USER_ROLE {
  ADMIN = "quanly",
  DIEU_HANH = "dieuhanhvien",
  NGUOI_DUNG = "nguoidung",
}
